export const ICL_PAY_REQUEST = "ICL_PAY_REQUEST";
export const ICL_PAY_SUCCESS = "ICL_PAY_SUCCESS";
export const ICL_PAY_FAILURE = "ICL_PAY_FAILURE";
export const UN_CLICK_SUMMIT_BUTTON = "UN_CLICK_SUMMIT_BUTTON";